import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../components/CustomFormsComponents/CustomField';
import dayjs from 'dayjs';

const useExtendAvisoObraFieldsConfig = ({
    t,
    formData,
    handleBlurValidation,
    selectedObra
}: any) => {
    const [fieldsConfig, setFieldsConfig] = useState<FieldConfig[]>([]);

    useEffect(() => {
        const fechaFinObra = selectedObra?.fechaFin ? dayjs(selectedObra.fechaFin) : null;

        setFieldsConfig([
            {
                type: 'date-mui',
                label: t('avisoObraForms.extend.inputs.extensionDate') as string,
                name: 'extensionDate',
                required: true,
                value: formData.extensionDate,
                disabled: false,
                helperText: fechaFinObra
                    ? `Debe ser posterior a ${fechaFinObra.format('DD/MM/YYYY')}`
                    : t('avisoObraForms.extend.inputs.extensionDate'),
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                minDate: fechaFinObra ? fechaFinObra.add(2, 'day').format('YYYY-MM-DD') : undefined
            },
            {
                type: 'text',
                label: t('avisoObraForms.extend.inputs.observation') as string,
                name: 'observation',
                required: true,
                value: formData.observation,
                disabled: false,
                helperText: t('avisoObraForms.extend.inputs.observation') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }]
            }
        ]);
    }, [selectedObra, t]);

    return {
        fieldsConfig
    };
};

export default useExtendAvisoObraFieldsConfig;
